import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from './pages/Home';
import Placeholder from './pages/Placeholder';
import Admin from './pages/Admin';
import Login from './pages/Login';
import UpdateProgress from './pages/UpdateProgress';
import Posts from './pages/Updates';
import UpdateDetail from './pages/UpdateDetail';
import Faqs from './pages/Faqs';
import Gear from './pages/Gear';
import GPSTracker from './pages/GPSTracker';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import apiConfig from './config/api';

const App = () => {
  const [loading, setLoading] = useState(true);
  const [placeholderMode, setPlaceholderMode] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${apiConfig.baseUrl}/api/settings`);
        const data = await response.json();
        
        setPlaceholderMode(data.placeholderMode);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching settings:', error);
        setLoading(false);
      }
    };
    
    fetchSettings();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={placeholderMode ? <Placeholder /> : <Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/posts/:id" element={<UpdateDetail />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/gear" element={<Gear />} />
            <Route path="/gps" element={<GPSTracker />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/update-progress" 
              element={
                <ProtectedRoute>
                  <UpdateProgress />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
